import { action, makeObservable, observable } from 'mobx';
import { RevenueTotal } from 'src/integration/types/RevenueTotal';

class RevenueTotalStore {
  @observable revenueTotal: RevenueTotal = {
    timestamp: "",
    dayRevenue: {
      amount: 0,
      currency: "€"
    },
    revenueMonth: {
      amount: 0,
      currency: "€"
    },
    revenueYear: {
      amount: 0,
      currency: "€"
    },
    revenueAllTime: {
      amount: 0,
      currency: "€"
    },
  };

  @action setRevenueTotalData = (data: SimpleObject) => {
    this.revenueTotal = {
      timestamp: data.timestamp || 0,
      dayRevenue: data.dayRevenue || 0,
      revenueMonth: data.revenueMonth || 0,
      revenueYear: data.revenueYear || 0,
      revenueAllTime: data.revenueAllTime || 0,
    }
  };

  constructor() {
    makeObservable(this);
  }
}

export default RevenueTotalStore;
